<template>
  <div class="project-description">
    <el-tabs v-model="activeName" type="border-card" @tab-click="getData">
      <el-tab-pane
        :label="$lange == 'en' ? 'Project' : '项目详情'"
        name="description"
      >
        <template v-if="showData">
          <ProjectComponent></ProjectComponent>
        </template>
      </el-tab-pane>
      <el-tab-pane :label="$lange == 'en' ? 'Task' : '任务分配'" name="task">
        <div class="task" v-if="productData">
          <div class="task-top">
            <p>{{ $lange == "en" ? "Project No." : "编号"}}: {{ productData.fasId }}</p>
            <p v-if="productData.customer">
              客户: {{ productData.customer.customerName || "---" }}
            </p>
            <!--                        <p>产品线序列号: S/Line0001</p>-->
            <p>
              {{ $lange == "en" ? "Project Type" : "项目类型" }}:
              {{ projectTypeArr[productData.status] }}
            </p>
            <p>
              {{ $lange == "en" ? "Project Time" : "项目时间" }}:
              {{
                `${moment(productData.warrantyStartTime).format(
                  "YYYY-MM-DD"
                )} ~ ${moment(productData.warrantyEndTime).format(
                  "YYYY-MM-DD"
                )}` || "---"
              }}
            </p>
          </div>
          <div class="content">
            <div class="task-title">
              <p>
                {{ $lange == "en" ? "Project Manager" : "项目经理" }}:
                {{ projectData.managerName || "---" }}
              </p>
              <p>
                {{ $lange == "en" ? "Team" : "团队成员" }}:
                {{ userNames || "---" }}
              </p>
              <div>
                <span v-if="taskTypeArr.length > 0"
                  >{{ $lange == "en" ? "Status" : "状态" }}:
                  {{ taskTypeArr[projectData.status || 0] }}</span
                >
                <!--                                <cc-constant-selector style="display:inline-block;"-->
                <!--                                                      type="select"-->
                <!--                                                      valType="String"-->
                <!--                                                      placeholder="请选择状态"-->
                <!--                                                      v-model="taskType"-->
                <!--                                                      code="taskType"-->
                <!--                                                      api="admin/dict/pageTree"/>-->
              </div>
            </div>
            <el-row
              style="margin-top: 20px"
              v-if="ganttData.length > 0"
              type="flex"
            >
              <el-col :span="15">
                <div class="table-box not-padding table-bottom">
                  <cc-table
                    :config="ganttTableConfig"
                    :dataArr="ganttData"
                    :loadData="tableFlag"
                    :stripe="false"
                  ></cc-table>
                </div>
              </el-col>
              <el-col :span="9">
                <div class="ganntt-box">
                  <Gantt
                    :utasks="ganttData"
                    :isMerge="true"
                    v-if="!showMembers"
                    :childHeight="childHeight"
                  ></Gantt>
                </div>
              </el-col>
            </el-row>
            <div class="btn-group" v-if="projectData.installStatus !== 2">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                @click="showAddTaskDialog"
                >{{ $lange == "en" ? "Edit Task" : "编辑任务" }}</el-button
              >
            </div>
            <div
              class="btn-group flex-between"
              v-if="projectData.installStatus !== 2"
            >
              <el-button
                size="small "
                type="primary"
                @click="pushApplet"
                v-if="projectData.isOpen === 0"
                >{{ $lange == "en" ? "Push applet" : "推送小程序" }}</el-button
              >
              <el-button size="small " type="primary" @click="submitAudit">{{
                $lange == "en" ? "Submit audit" : "提交审核"
              }}</el-button>
              <el-button
                size="small "
                type="primary"
                @click="acceptanceReportFun"
                >{{
                  $lange == "en" ? "Upload Acceptance report" : "上传验收报告"
                }}</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="back-btn">
      <el-button type="primary" size="mini" @click="backBtn('/workbench')"
        >返回首页</el-button
      >
      <el-button
        type="warning"
        size="mini"
        @click="backBtn('/admin/project/list')"
        >返回列表</el-button
      >
    </div>
    <el-dialog
      :title="$lange == 'en' ? 'Appointees' : '指派人员'"
      :visible.sync="showMembers"
      width="80%"
      v-loading="dialogLoading"
      append-to-body
    >
      <div style="margin-bottom: 15px">
        {{ $lange == "en" ? "Choice scope" : "选择范围" }}:
        <el-date-picker
          v-model="membersSearch.startTime"
          style="width: 150px"
          value-format="yyyy-MM-dd"
          type="date"
          @change="getMembers"
          size="mini"
          :placeholder="$lange == 'en' ? 'Choose Date' : '选择日期'"
        ></el-date-picker>
        {{ $lange == "en" ? "to" : "到" }}
        <el-date-picker
          v-model="membersSearch.endTime"
          style="width: 150px"
          value-format="yyyy-MM-dd"
          type="date"
          size="mini"
          @change="getMembers"
          :placeholder="$lange == 'en' ? 'Choose Date' : '选择日期'"
        ></el-date-picker>
      </div>

      <div>
        {{ $lange == "en" ? "Assignment date" : "指派日期" }}:
        <el-date-picker
          v-model="ganttDateRange.startTime"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 150px"
          @change="showGanttDate"
          size="mini"
          :placeholder="$lange == 'en' ? 'Choose Date' : '选择日期'"
        ></el-date-picker>
        {{ $lange == "en" ? "to" : "到" }}
        <el-date-picker
          v-model="ganttDateRange.endTime"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 150px"
          size="mini"
          @change="showGanttDate"
          :placeholder="$lange == 'en' ? 'Choose Date' : '选择日期'"
        ></el-date-picker>
      </div>

      <div class="engineer-box flex-between" v-if="membersData.length > 0">
        <p style="min-width: 130px">
          {{ $lange == "en" ? "Engineer" : "工程师" }}:
          {{ membersData[membersTableConfig.radioValue].userName }}
        </p>
        <!--                <el-checkbox v-model="isLeader">{{$lange == 'en' ? 'Captain' : '指派为组长'}}</el-checkbox>-->
      </div>
      <el-row style="margin-top: 20px">
        <el-col :span="10">
          <div class="table-box not-padding">
            <cc-table
              :config="membersTableConfig"
              :dataArr="membersData"
              :load-data="false"
            ></cc-table>
          </div>
        </el-col>
        <el-col :span="14">
          <Gantt
            :utasks="membersData"
            :isAssign="true"
            :is-start-time="membersSearch.startTime"
            :isAddWeek="true"
            :is-end-time="membersSearch.endTime"
            v-if="membersGantt"
            :childHeight="36"
          ></Gantt>
        </el-col>
      </el-row>
      <div class="btn-box flex-between">
        <el-button
          type="info"
          size="mini"
          style="margin-right: 20px"
          @click="showMembers = false"
          >{{ $lange == "en" ? "Cancel" : "取消" }}</el-button
        >
        <el-button type="primary" size="mini" @click="saveMembers">{{
          $lange == "en" ? "Submit" : "提交"
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Edit Task' : '编辑任务'"
      :visible.sync="showAddTask"
      width="80%"
      append-to-body
    >
      <cc-table
        :key="tasksTableData.length"
        :config="tasksTableConfig"
        :refesh-params="tasksTableRefer"
        :dataArr="tasksTableData"
        :load-data="false"
      ></cc-table>
      <div
        class="flex-between"
        style="justify-content: flex-end; margin-top: 10px"
      >
        <el-button size="mini" @click="showAddTaskLists">{{
          $lange == "en" ? "Add Task" : "添加任务"
        }}</el-button>
      </div>
      <div class="flex-between" style="justify-content: center">
        <el-button size="mini " @click="showAddTask = false">{{
          $lange == "en" ? "Cancel" : "取消"
        }}</el-button>
        <el-button size="mini " type="primary" @click="saveTasksLists">{{
          $lange == "en" ? "Submit" : "提交"
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Add Task' : '添加'"
      :visible.sync="addTaskLists"
      v-loading="dialogLoading"
      width="80%"
      append-to-body
    >
      <el-select
        v-model="childTasksTableParams.parentId"
        :placeholder="
          $lange == 'en' ? 'Please Select Task Type' : '请选择任务类型'
        "
        @change="parentTasksChange"
        size="mini"
        style="margin-bottom: 15px"
        clearable 
      >
        <el-option
          v-for="item in parentTasks"
          :label="item.tasksName"
          :value="item.id"
        ></el-option>
      </el-select>
      <span style="display: inline-block; max-width: 200px; margin-left: 20px">
        <el-input
          size="mini"
          v-model="childTasksTableParams.productLine"
          :placeholder="
            $lange == 'en' ? 'Please Input Product Line' : '请输入产线'
          "
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </span>

      <!--            :load-data="childTasksTableParams.parentId.length > -1"-->
      <cc-table
        :config="childTasksTableConfig"
        :params="childTasksTableParams"
        :refesh-params="childTasksTableRefesh"
        @submit-select="submitTask"
      ></cc-table>
      <!--            <div class="flex-between"  style="justify-content: flex-end;margin-top: 10px;">-->
      <!--                <el-button size="mini" @click="showAddTaskLists" > 添加任务 </el-button>-->
      <!--            </div>-->
      <!--            <div class="flex-between" style="justify-content: center;">-->
      <!--                <el-button size="mini " > 取消 </el-button>-->
      <!--                <el-button size="mini " type="primary" > 提交 </el-button>-->

      <!--            </div>-->
    </el-dialog>
    <el-dialog
      title="上传验收报告"
      :visible.sync="acceptanceReportFlag"
      width="30%"
      append-to-body
    >
      <!--            <div class="img-lists flex-between">-->
      <!--                <div class="img-list"-->
      <!--                     :style="'background:url('+item.accessoryUrl+') no-repeat center / cover'"-->
      <!--                     v-for="item in acceptanceReportForm.batchFileInfoList"></div>-->
      <!--                <div class="img-list">-->
      <!--                    <cc-uploader :config="uploaderConf2"-->
      <!--                                 uploadType="dottedLine"-->
      <!--                                 :useSuccess="true"-->
      <!--                                 @upload-success="acceptanceReportUploadSuccess"-->
      <!--                                 :isMultiple="true"-->
      <!--                    />-->
      <!--                </div>-->

      <!--            </div>-->
      <cc-uploader :config="uploaderConf2" v-model="reportUrl" />
      <div style="color: #909399; margin-top: 10px">
        <i class="el-icon-warning"></i> 上传验收报告后会结束此项目任务!
      </div>
      <div style="color: #909399; margin-top: 10px">
        <i class="el-icon-warning"></i>
        提交完验收报告工程师将不能提交日报,做好提醒。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="acceptanceReportFlag = false">{{
          $lange == "en" ? "Cancel" : "取消"
        }}</el-button>
        <el-button type="primary" @click="submitAcceptanceReport">{{
          $lange == "en" ? "Submit" : "提交"
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? 'Engineer' : '工程师'"
      :visible.sync="showEngineer"
      width="450px"
      append-to-body
    >
      <el-form
        size="mini"
        label-width="120px"
        v-loading="dialogLoading"
        v-if="engineerData.sysUserInfo.username"
      >
        <el-form-item label>
          <div
            class="img-box"
            :style="`transform: translateX(-46px);background: url(${
              engineerData.sysUserInfo.avatarurl.length > 0
                ? engineerData.sysUserInfo.avatarurl
                : notImageUrl
            }) no-repeat center / cover`"
          ></div>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Name: ' : '名称: '">
          <span>{{ engineerData.sysUserInfo.username }}</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Department: ' : '部门: '">
          <span>{{ engineerData.sysUserInfo.deptName }}</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Category: ' : '类别: '">
          <span>{{ engineerData.sysUserInfo.categoryName }}</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Resident: ' : '驻地: '">
          <span>{{ engineerData.sysUserInfo.station }}</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Skill: ' : '技能: '">
          <span>{{ engineerData.sysUserInfo.skill }}</span>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Language ability: ' : '语言能力: '"
        >
          <span>{{ engineerData.sysUserInfo.langSkills }}</span>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Target business trip' : '目标出差'"
        >
          <span>{{ engineerData.sysUserInfo.travelDays }}天</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Other: ' : '其他: '">
          <template v-if="$lange == 'en'">
            <el-tag type="success" style="margin-right: 10px"
              >Cumulative travel {{ engineerData.travelDaysTotal }} Day</el-tag
            >
            <el-tag type="success"
              >Accumulated working hours
              {{ engineerData.workHourTotal }}</el-tag
            >
          </template>
          <template v-else>
            <el-tag type="success" style="margin-right: 10px"
              >累计出差{{ engineerData.travelDaysTotal }}天</el-tag
            >
            <el-tag type="success"
              >累计工时{{ engineerData.workHourTotal }}小时</el-tag
            >
          </template>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ProjectComponent from "./components/ProjectComponent";
import Gantt from "../../components/Gantt";
import moment from "moment";
import Status from "./components/Status.vue"
 import isAudit from "./components/isAudit.vue"
let notImageUrl = require("../../assets/not-image.png");
export default {
  name: "ProjectDescription",
  components: {
    ProjectComponent,
    Gantt,
  },
  watch: {
    "membersTableConfig.radioValue": {
      handler(newData, lastData) {
        // if(this.membersData[lastData].items && this.membersData[lastData].items.length > 0){
        for (let i in this.membersData[lastData].items) {
          if (this.membersData[lastData].items[i].value == "选中") {
            this.membersData[lastData].items.splice(i, 1);
          }
        }
        // }
        let data = this.ganttDateRange;
        if (this.ganttDateRange.startTime.length < 1) {
          return false;
        }
        data.value = "选中";
        data.workType = 3;
        this.membersData[newData].items.push(data);
      },
    },
    tasksTableData: {
      handler() {
        console.log(this.tasksTableData);
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      notImageUrl: notImageUrl,
      showEngineer: false, //任务指派的时候, 点击查看工程师的数据
      //任务指派的时候, 点击查看工程师的数据
      engineerData: {
        sysUserInfo: {},
        travelDaysTotal: 2,
        workHourTotal: 0,
      },
      reportUrl: "",
      moment: moment,
      showData: false,
      uploaderConf2: this.$uploadUtils.config,
      acceptanceReportFlag: false,
      acceptanceReportForm: {
        objId: "",
        objType: "product",
        projectId: "",
        batchFileInfoList: [],
      },
      childHeight: 41,
      ganttDateRange: {
        startTime: "",
        endTime: "",
      },
      membersSearch: {
        startTime: moment(new Date()).format("YYYY-MM-DD"),
        endTime: moment(new Date()).format("YYYY-MM-DD"),
      },
      projectUserId: false,
      fasId: "",
      addTaskLists: false,
      tasksTableRefer: -1,
      projectChildTaskId: false,
      showAddTask: false,
      userNames: "",
      projectTypeArr: ["---", "安装项目", "售后服务"],
      dialogLoading: false,
      activeName: "description",
      statusValue: "shanghai",
      refGantt: -1,
      tableFlag: false,
      ganttFlag: true,
      ganttTableConfig: {
        rowClassName: ({ row, rowIndex }) => {
          if (row.isLeader === undefined) {
            return "info-row";
          } else {
            return "";
          }
        },
        height: "150px",
        showIndex: false,
        columns: [
          {
            prop: "tasksTitle",
            lable: this.$lange == "en" ? "Tasks Name" : "任务名称",
            type: "input",
          },
          {
            prop: "userName",
            lable: this.$lange == "en" ? "Team" : "团队成员",
            minWidth: "200",
            render: function (row) {
              let res = `${row.userName}`;
              let str = this.$lange == "en" ? "(L)" : "(队)";
              if (row.isLeader === 1) {
                res = `${str} ${row.userName}`;
              }

              return row.userName && row.userName.length > 0 ? res : "---";
            },
          },
          {
            prop: "startTime",
            lable: this.$lange == "en" ? "Estimated start time" : "预计开始",
            type: "datetime",
            minWidth: "90px",
            render: (row) => {
              return moment(row.startTime).format("YYYY-MM-DD");
            },
          },
          {
            prop: "endTime",
            lable: this.$lange == "en" ? "Estimated end time" : "预计结束",
            type: "datetime",
            minWidth: "90px",
            render: (row) => {
              return moment(row.endTime).format("YYYY-MM-DD");
            },
          },
          {
            prop: "workHour",
            lable: this.$lange == "en" ? "Estimated total hours" : "预计总工时",
            type: "input",
            minWidth: "100px",
          },
          {
            prop: "relStartTime",
            lable: this.$lange == "en" ? "Actual start time" : "实际开始",
            type: "date",
            minWidth: "90px",
            render: (row) => {
              return row.relStartTime
                ? moment(row.relStartTime).format("YYYY-MM-DD")
                : "---";
            },
          },
          {
            prop: "relEndTime",
            lable: this.$lange == "en" ? "Actual end time" : "实际结束",
            type: "date",
            minWidth: "90px",
            render: (row) => {
              return row.relEndTime
                ? moment(row.relEndTime).format("YYYY-MM-DD")
                : "---";
            },
          },
          {
            prop: "relWorkHour",
            lable: this.$lange == "en" ? "Actual total hours" : "实际总工时",
            type: "input",
            minWidth: "90px",
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Status" : "任务状态",
            type: "component",
            componentName: Status,

            // type: "tag",
            // options: [
            //   {
            //     tagType: "info",
            //     text: this.$lange == "en" ? "Not yet begun" : "未开始",
            //   },
            //   {
            //     tagType: "warning",
            //     text: this.$lange == "en" ? "Have in hand" : "进行中",
            //   },
            //   {
            //     tagType: "success",
            //     text: this.$lange == "en" ? "Completed" : "已完成",
            //   },
            //   {
            //     tagType: "danger",
            //     text: this.$lange == "en" ? "Delay" : "延迟",
            //   },
            // ],
            // type: "constant",
            // constantConfig: {
            //     api: "admin/dict/pageTree",
            //     code: "taskType",
            //     type: "input",
            //     opts: { 0: "info", 1: "success",  2: "danger"}
            // },
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remark" : "任务备注",
            minWidth: "120",
            render: (row) => {
              let res = "---";
              if (row.remark && row.remark.length > 0) {
                res = row.remark;
              }
              return res;
            },
          },
          {
            prop: "isAudit",
            lable: this.$lange == "en" ? "Audit Status" : "审批状态",
                   type: "component",
            componentName: isAudit,
            // type: "tag",
            // options: [
            //   {
            //     tagType: "warning",
            //     text: this.$lange == "en" ? "To be audited" : "待审核",
            //   },
            //   {
            //     tagType: "success",
            //     text: this.$lange == "en" ? "Have passed" : "已通过",
            //   },
            //   {
            //     tagType: "danger",
            //     text: this.$lange == "en" ? "Not pass" : "未通过",
            //   },
            //   {
            //     tagType: "info",
            //     text: this.$lange == "en" ? "Not submitted" : "未提交",
            //   },
            // ],
          },
          {
            prop: "reviewMessage",
            lable: this.$lange == "en" ? "Audit Remark" : "审批备注",
            minWidth: "120",
            render: (row) => {
              let res = "---";
              if (row.reviewMessage && row.reviewMessage.length > 0) {
                res = row.reviewMessage;
              }
              return res;
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Edit" : "编辑",
            btnColor: "btn-gary-color",
            check: (row) => {
              return row.isLeader !== undefined && row.isAudit !== 0;
            },
            click: (row) => {
              // console.log(row, "1111")
              // this.membersTableConfig.radioValue
              this.projectUserId = row.userId;
              this.projectChildTaskId = row.id;
              this.projectTasksId = row.projectTasksId
                ? row.projectTasksId
                : row.id;
              this.membersSearch.userId = row.userId;
              this.getMembers();
              this.membersSearch.startTime = moment(row.startTime).format(
                "YYYY-MM-DD"
              );
              this.membersSearch.endTime = moment(row.endTime).format(
                "YYYY-MM-DD"
              );
              this.ganttDateRange.startTime = moment(row.startTime).format(
                "YYYY-MM-DD"
              );
              this.ganttDateRange.endTime = moment(row.endTime).format(
                "YYYY-MM-DD"
              );
              this.showMembers = true;
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "删除",
            btnColor: "btn-gary-color",
            check: (row) => {
              return row.isLeader !== undefined;
            },
            click: (row, $index) => {
              this.$confirm("此操作会删除该指派?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  let data = {
                    id: row.id,
                  };
                  this.ccRequest
                    .do("admin/fsb/employee/delete", data, "GET")
                    .then((res) => {
                      this.$message({
                        type: "success",
                        message: "该指派已删除",
                      });
                      this.getTask();
                    });
                })
                .catch(() => {
                  // this.$message({
                  //     type: 'info',
                  //     message: '已取消删除'
                  // });
                });
            },
          },
          {
            name: this.$lange == "en" ? "Assign" : "指派",
            check: (row) => {
              return row.isLeader === undefined;
            },
            click: (row) => {
              this.projectTasksId = row.id;
              this.getMembers();
              this.membersSearch.startTime = moment(row.startTime).format(
                "YYYY-MM-DD"
              );
              this.membersSearch.endTime = moment(row.endTime).format(
                "YYYY-MM-DD"
              );
              this.ganttDateRange.startTime = moment(row.startTime).format(
                "YYYY-MM-DD"
              );
              this.ganttDateRange.endTime = moment(row.endTime).format(
                "YYYY-MM-DD"
              );
              this.showMembers = true;

              // this.ccRequest.do("admin/fsb/employee/getLeader", {projectTasksId: row.id}, "GET").then(res => {
              //     this.isLeader = !res;
              // })
            },
          },
          {
            name: this.$lange == "en" ? "Set leader" : "设置为队长",
            btnColor: "btn-gary-color",
            check: (row) => {
              let res = false;
              if (row.isLeader !== undefined && row.isLeader !== 1) {
                res = true;
              }
              return res;
            },
            click: (row) => {
              // 设置队长：/admin/fsb/employee/updateCaptain 参数：id（员工任务的id） projectTasksId（项目任务的id） isLeader（0-非组长，1-组长）
              this.ccRequest
                .do(
                  "admin/fsb/employee/updateCaptain",
                  {
                    id: row.id,
                    projectTasksId: row.projectTasksId,
                    isLeader: 1,
                  },
                  "GET"
                )
                .then((res) => {
                  this.$message({
                    type: "success",
                    message: "设置成功",
                  });
                  this.getTask();
                })
                .catch((res) => {
                  this.$message({
                    type: "warning",
                    message: "一个任务只能存在一个队长",
                  });
                });
            },
          },
          {
            name: this.$lange == "en" ? "Cancel leader" : "取消队长",
            btnColor: "btn-gary-color",
            check: (row) => {
              let res = false;
              if (row.isLeader === 1) {
                res = true;
              }
              return res;
            },
            click: (row) => {
              this.ccRequest
                .do(
                  "admin/fsb/employee/updateCaptain",
                  {
                    id: row.id,
                    projectTasksId: row.projectTasksId,
                    isLeader: 0,
                  },
                  "GET"
                )
                .then((res) => {
                  this.$message({
                    type: "success",
                    message: "设置成功",
                  });
                  this.getTask();
                });
            },
          },
        ],
      },
      membersTableConfig: {
        radioValue: 0,
        showIndex: false,
        height: "150px",
        columns: [
          {
            prop: "radioValue",
            lable: "选择",
            type: "radio",
            minWidth: "40px",
          },
          {
            prop: "userName",
            lable: "工程师",
            type: "click",
            clickFun: (row) => {
              let pData = {
                userId: row.userId,
              };
              this.showEngineer = true;
              this.dialogLoading = true;
              this.ccRequest
                .do("admin/fsb/employeeinfo/getEmployeeInfo", pData, "GET")
                .then((res) => {
                  this.engineerData = res;
                  this.dialogLoading = false;
                })
                .catch((res) => {
                  this.dialogLoading = false;
                });
            },
          },
          {
            lable: "目前所在位置",
            render: (row) => {
              let res = row.station;
              let data = row.items;
              let today = moment(new Date()).format("YYYY-MM-DD");
              if (row.items) {
                for (let i in data) {
                  // console.log(data[i].startTime < today , data[i].endTime > today)
                  if (
                    data[i].startTime < today &&
                    data[i].endTime > today &&
                    data[i].workType !== 3
                  ) {
                    if (data[i].product) {
                      res = data[i].product.productAddress;
                    }
                  }
                }
              }

              // res = row.
              return res;
            },
          },
          {
            prop: "skill",
            lable: "技能",
          },
        ],
      },
      ganttData: [],
      productData: {},
      showMembers: false,
      projectTasksId: false,
      membersData: [],
      nowMember: true,
      membersGantt: false,
      isLeader: false,
      taskType: 0,
      tasksTableConfig: {
        // api: "",
        // showPager: false,
        columns: [
          {
            prop: "tasksTitle",
            lable: "任务标题",
            type: "input",
          },
          {
            prop: "workHour",
            lable: "预估工时",
            type: "input",
            minWidth: "20px",
          },
          {
            prop: "dateRangeTime",
            lable: "服务时间",
            type: "daterange",
            // render() {
            //   return "";
            // },
          },
          {
            prop: "remark",
            lable: "备注",
            type: "editinput",
            placeholer: "请输入备注",
            render() {
              return "";
            },
          },
        ],
        buttons: [
          {
            name: "删除",
            click: (row, $index) => {
              let returnText = "此操作会删除该任务, 是否确定?";
              if (row.items !== undefined && row.items.length > 0) {
                returnText = "此任务下已安排工程师，确认删除";
              }
              if (row.status > 0) {
                return this.$message({
                  type: "error",
                  message: "任务已开始, 无法删除",
                });
              }
              this.$confirm(returnText, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.tasksTableData.splice($index, 1);
                  this.$message({
                    type: "success",
                    message: "任务已删除",
                  });
                  this.ganttFlag = false;
                  this.getTask();
                  this.tasksTableRefer = new Date().getTime();
                })
                .catch(() => {
                  // this.$message({
                  //     type: 'info',
                  //     message: '已取消删除'
                  // });
                });
            },
          },
        ],
      },
      tasksTableData: [],
      parentTasks: [],
      childTasksTableRefesh: 0,
      childTasksTableConfig: {
        api: "admin/fsb/job/query",
        selectType: "Object",
        columns: [
          {
            prop: "tasksName",
            lable: "任务内容",
          },
          {
            prop: "workHour",
            lable: "工时",
          },
          {
            prop: "productLine",
            lable: "适合产线",
            render: (row) => {
              let res = "";
              for (let i in row.productLine) {
                res += `${row.productLine[i]}`;

                if (i < row.productLine.length - 1) {
                  res += ",";
                }
              }
              return res;
            },
          },
        ],
        selection: [],
      },
      childTasksTableParams: {
        parentId: 10,
        productLine: "",
      },
      projectData: {},
      taskTypeArr: ["安装", "启动", "调试", "验收"],
    };
  },
  methods: {
    //上传验收报告之前 检查是否未完成项目
    acceptanceReportFun() {
      for (let i in this.ganttData) {
        if (this.ganttData[i].status !== -1 && this.ganttData[i].status !== 2) {
          return this.$message({
            type: "danger",
            message: "部分任务未完成, 不能提交验收报告",
          });
        }
      }
      this.acceptanceReportFlag = true;
    },
    submitAcceptanceReport() {
      if (this.reportUrl.length < 1) {
        return this.$message({
          type: "warning",
          message: "请上传验收报告文件",
        });
      }
      let data = this.acceptanceReportForm;
      data.batchFileInfoList = [
        {
          fileName: `项目验收报告`,
          accessoryUrl: this.reportUrl,
        },
      ];
      data.projectId = this.projectData.id;
      data.objId = this.productData.jobId;
      this.ccRequest
        .do("admin/fsb/project/acceptanceReport", data, "POSTJSON")
        .then((res) => {
          this.acceptanceReportFlag = false;
          this.getData();
          this.$message({
            type: "success",
            message: "提交成功",
          });
        })
        .catch((res) => {
          this.showData = true;
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },

    showGanttDate() {
      for (let i in this.membersData) {
        for (let j in this.membersData[i].items) {
          if (this.membersData[i].items[j].value == "选中") {
            let data = {
              ...this.membersData[i].items[j],
              ...this.ganttDateRange,
              workType: 3,
            };
            this.membersData[i].items.splice(j, 1);
            this.membersData[i].items.push(data);
          }
        }
      }
      // this.membersGantt  = false;
      // let data = this.ganttDateRange;
      // data.value = "选中";
      // data.status = 4;
      // this.membersData[newData].items.push(data)
    },
    pushApplet() {
      let data = {
        id: this.projectData.id,
        isOpen: 1,
      };
      this.$confirm("此操作会将项目推送给客户、项目经理、工程师", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.projectData.isOpen = 1;
        this.ccRequest
          .do("admin/fsb/project/save", data, "POSTJSON")
          .then((res) => {
            this.$message({
              type: "success",
              message: "推送成功",
            });
            this.projectData.isOpen = 1;
          })
          .catch((res) => {
            this.$message({
              type: "warning",
              message: "推送失败, 请重试",
            });
            this.projectData.isOpen = 0;
          });
      });
    },
    submitAudit() {
      this.$confirm("确定全部提交审核吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let idx = [];
          for (let i in this.ganttData) {
            if (this.ganttData[i].isLeader === undefined) {
              idx.push(this.ganttData[i].id);
            }
          }

          let data = {
            ids: idx.join(","),
            fasId: this.fasId,
          };
          this.ccRequest
            .do("admin/fsb/employee/submitAudit", data, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "已提交",
              });
              this.getData();
            });
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消'
          // });
        });
    },
    saveTasksLists() {
      this.ganttFlag = false;
      let data = {
        jobId: this.productData.jobId,
        projectTasksList: this.tasksTableData,
      };
      if (data.projectTasksList != "") {
        for (let i in data.projectTasksList) {
          if (
            !data.projectTasksList[i].dateRangeTime ||
            data.projectTasksList[i].dateRangeTime.length < 1
          ) {
            this.$message({
              type: "warning",
              message: "请注意输入时间",
            });
            return false;
          }
        }
      }
      this.ccRequest
        .do("admin/fsb/project/task/batchSave", data, "POSTJSON")
        .then((res) => {
          this.showAddTask = false;
          this.getTask();
          this.$message({
            type: "success",
            message: "提交成功",
          });
        });
    },
    showAddTaskDialog() {
      this.showAddTask = true;
      let data = {
        fasId: this.fasId,
        objType: 0,
      };
      this.ccRequest
        .do("admin/fsb/project/task/query", data, "GET")
        .then((res) => {
          this.tasksTableData = res.rows;
        });
    },
    submitTask(ids) {
      let tasksTableData = JSON.parse(JSON.stringify(this.tasksTableData));
      this.tasksTableData = [];
      for (let i = 0; i < ids.length; i++) {
        let data = {};
        data = ids[i];
        data.dateRangeTime = [];
        data.remark = "";
        data.tasksTitle = ids[i].tasksName;
        data.jobId = this.productData.jobId;
        data.fasId = this.fasId;
        data.objId = ids[i].id;
        delete data.id;
        tasksTableData.push(data);
      }
      this.tasksTableData = JSON.parse(JSON.stringify(tasksTableData));

      this.addTaskLists = false;
      //废弃一下
      //   this.ccRequest
      //     .do(
      //       "admin/fsb/job/query",
      //       { parentId: this.childTasksTableParams.parentId, pageSize: 100000 },
      //       "GET"
      //     )
      //     .then((res) => {
      //       for (let i in res.rows) {
      //         for (let j in ids) {
      //           let data = {};
      //           if (res.rows[i].id === ids[j]) {
      //             data = res.rows[i];
      //             data.dateRangeTime = [];
      //             data.remark = "";
      //             data.tasksTitle = res.rows[i].tasksName;
      //             data.jobId = this.productData.jobId;
      //             data.fasId = this.fasId;
      //             data.objId = res.rows[i].id;
      //             delete data.id;
      //             this.tasksTableData.push(data);
      //           }
      //         }
      //       }
      //       this.addTaskLists = false;
      //     })
      //     .catch(() => {
      //       this.dialogLoading = false;
      //     });
    },
    parentTasksChange(res) {
      console.log(this.childTasksTableConfig.selection);
    },
    showAddTaskLists() {
      this.dialogLoading = true;
      this.ccRequest
        .do("admin/fsb/job/query", { parentId: 0 }, "GET")
        .then((res) => {
          this.addTaskLists = true;
          this.dialogLoading = false;
          this.childTasksTableRefesh = new Date().getTime();
          this.parentTasks = res.rows;
          if (this.$lange == "en") {
            this.parentTasks.unshift({
              tasksName: "All",
              id: 10,
            });
          } else {
            this.parentTasks.unshift({
              tasksName: "全部",
              id: 10,
            });
          }
        })
        .catch(() => {
          this.dialogLoading = false;
        });
    },
    saveMembers() {
      let data = {
        startTime: this.ganttDateRange.startTime,
        endTime: this.ganttDateRange.endTime,
        userId: this.membersData[this.membersTableConfig.radioValue].userId,
        // isLeader: this.isLeader ? 1 : 0,
        projectTasksId: this.projectTasksId,
        jobId: this.productData.jobId,
      };
      if (this.ganttDateRange.startTime > this.ganttDateRange.endTime) {
        return this.$message({
          type: "warning",
          message: "开始时间不能大于结束时间",
        });
      }
      this.ganttFlag = false;
      this.projectChildTaskId ? (data.id = this.projectChildTaskId) : false;
      this.ccRequest
        .do("admin/fsb/employee/save", data, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: "提交成功",
          });
          this.projectChildTaskId = false;
          this.showMembers = false;
          this.projectUserId = false;
          this.getTask();
        })
        .catch((res) => {
          // console.log(res.response.data.message)
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    getMembers() {
      this.membersData = [];
      this.membersGantt = false;
      let data = this.membersSearch;
      if (this.projectUserId) {
        data.userId = this.projectUserId;
      }
      delete data.value;
      this.membersTableConfig.radioValue = 0;
      this.ccRequest
        .do("admin/fsb/project/task/queryTasksIsNull", data, "GET")
        .then((res) => {
          if (res.length > 0) {
            for (let i in res) {
              if (res[i].items !== undefined && res[i].items.length > 0) {
                res[i].startTime = res[i].items[0].startTime;
                res[i].endTime = res[i].items[0].endTime;
                for (let j in res[i].items) {
                  if (res[i].items[j].customerName.length > 0) {
                    res[i].items[
                      j
                    ].value = `${res[i].items[j].customerName} —— ${res[i].items[j].value}`;
                  }
                }
              } else {
                //这里产生了会自己多一格的问题  先注释
                // res[i].startTime = this.ganttDateRange.startTime;
                // res[i].endTime = this.ganttDateRange.startTime;
              }
              // console.log(res[i], "res[i]")
            }
            let newData = {
              startTime: this.ganttDateRange.startTime,
              endTime: this.ganttDateRange.endTime,
              value: "选中",
              workType: 3,
            };
            res[this.membersTableConfig.radioValue].items.push(newData);
          }
          console.log(res, "showGantt");
          this.membersData = res;
          this.membersGantt = true;
          // this.dialogLoading = false;
        })
        .catch((res) => {
          console.log(res, "response");
          this.membersGantt = true;
          this.$message({
            type: "error",
            message: "选择的时间不在任务时间范围中",
          });
        });
    },
    getTask() {
      this.showData = false;
      let data = {
        fasId: this.fasId,
      };
      this.ccRequest
        .do("admin/fsb/project/task/queryTasks", data, "GET")
        .then((res) => {
          let data = res.tasks.rows;
          let newData = [];
          for (let i in data) {
            data[i].value = data[i].tasksTitle;
            newData.push(data[i]);
            if (data[i].items) {
              for (let j in data[i].items) {
                data[i].items[j].status = -1;
                newData.push(data[i].items[j]);
              }
            }
          }
          this.productData = res.product;
          this.projectData = res.project;
          this.userNames = res.userNames;
          this.ganttData = newData;
          console.log(this.ganttData,'ganttData')
          this.showData = true;
          if (res.project.status === 3) {
            delete this.ganttTableConfig.buttons;
            this.childHeight = 40;
          }
        });
    },
    backBtn(path) {
      this.$router.push({
        path: path,
      });
    },

    getData() {
      this.getTask();
    },
    checkLanguage() {
      if (this.$lange == "en") {
        this.taskTypeArr = [
          "Preparing",
          "Installation",
          "Commissioning",
          "Acceptance",
        ];

        this.membersTableConfig = {
          radioValue: 0,
          showIndex: false,
          height: "150px",
          columns: [
            {
              prop: "radioValue",
              lable: "Choose",
              type: "radio",
            },
            {
              prop: "userName",
              lable: "Engineer",
              type: "click",
              clickFun: (row) => {
                this.$router.push({
                  path: "/admin/staff/list/des",
                  query: {
                    id: row.userId,
                  },
                });
              },
            },
            {
              lable: "Current location",
              render: (row) => {
                let res = row.station;
                let data = row.items;
                let today = moment(new Date()).format("YYYY-MM-DD");
                if (row.items != "") {
                  for (let i in data) {
                    console.log(
                      data[i].startTime < today,
                      data[i].endTime > today
                    );
                    if (
                      data[i].startTime < today &&
                      data[i].endTime > today &&
                      data[i].workType !== 3
                    ) {
                      res = data[i].product.productAddress;
                    }
                  }
                }

                // res = row.
                return res;
              },
            },
            {
              prop: "skill",
              lable: "Skill",
            },
          ],
        };
        this.projectTypeArr = ["---", "Installing", "After sale"];
        this.tasksTableConfig = {
          columns: [
            {
              prop: "tasksTitle",
              lable: "TasksTitle",
              type: "input",
            },
            {
              prop: "workHour",
              lable: "Estimated working hours",
              type: "input",
              minWidth: "60px",
            },
            {
              prop: "dateRangeTime",
              lable: "Service time",
              minWidth: "120px",
              type: "daterange",
              render() {
                return "";
              },
            },
            {
              prop: "remark",
              lable: "Remark",
              type: "editinput",
              placeholer: "Please Input Remark",
              render() {
                return "";
              },
            },
          ],
          buttonsLabel: "Operation",
          buttons: [
            {
              name: "Delete",
              click: (row, $index) => {
                this.$confirm("此操作会删除该任务, 是否确定?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.tasksTableData.splice($index, 1);
                    // let data = {
                    //     id: row.id
                    // }
                    // this.ccRequest.do("admin/fsb/project/task/delete", data, "GET").then(res => {
                    this.$message({
                      type: "success",
                      message: "任务已删除",
                    });
                    // })
                    this.ganttFlag = false;
                    this.getTask();
                    this.tasksTableRefer = new Date().getTime();
                  })
                  .catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                  });
              },
            },
            {},
          ],
        };
        this.childTasksTableConfig = {
          api: "admin/fsb/job/query",
          columns: [
            {
              prop: "tasksName",
              lable: "TaskName",
            },
            {
              prop: "workHour",
              lable: "WorkHour",
            },
            {
              prop: "productLine",
              lable: "ProductLine",
              render: (row) => {
                let res = "";
                for (let i in row.productLine) {
                  res += `${row.productLine[i]}`;

                  if (i < row.productLine.length - 1) {
                    res += ",";
                  }
                }
                return res;
              },
            },
          ],
          selection: [],
        };
      }
    },
  },
  mounted() {
    this.checkLanguage();
    if (!this.$route.query.fasId) {
      this.$message({
        type: "danger",
        message: "参数错误",
      });
      this.$router.go(-1);
      return false;
    }
    this.fasId = this.$route.query.fasId;
    this.getData();
  },
};
</script>

<style>
.el-tabs--border-card {
  background: transparent;
}
.img-list .dottedUpload {
  min-width: 80px;
}
</style>
<style scoped lang="scss">
.img-box {
  width: 200px;
  height: 200px;
}
.project-description {
  .task {
    background: #ffffff;
    padding: 20px;
    box-sizing: border-box;
    .task-top {
      background: #ebeef5;
      padding: 5px 15px;
      display: flex;
      p {
        margin-right: 25px;
        font-size: 14px;
      }
    }
    .content {
      margin-top: 35px;
      .task-title {
        display: flex;
        > * {
          margin-right: 20px;
        }
        > div {
          margin-left: 25px;
        }
      }
      .table-box {
      }
    }
    .btn-group {
      border-bottom: 1px solid #e4e4e4;
      padding: 20px;
      &.flex-between {
        justify-content: center;
      }
    }
  }
  .engineer-box {
    margin: 20px 0 10px 0;
    justify-content: flex-start;
    p {
      margin-right: 15px;
    }
  }
  .btn-box {
    margin-top: 20px;
    justify-content: center;
  }
}
.img-lists {
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 15px;
  > .img-list {
    width: 80px;
    height: 80px;
    cursor: pointer;
    position: relative;
    &:not(:last-child) {
      border: 1px dotted #e4e4e4;
      border-radius: 3px;
      margin-right: 10px;
    }
  }
}
</style>
